import { chakra, useMultiStyleConfig } from "@chakra-ui/react";
import React from "react";

export const Footer = ({ children }: { children: React.ReactNode }) => {
  const styles = useMultiStyleConfig("SuiPage", {});
  return (
    <chakra.div className="border-t" __css={styles.header}>
      {children}
    </chakra.div>
  );
};
